/* pamela-clipart-library.js
   Clipart Panel UI (manifest-based)
   - Requires #pamela-view-clipart button to exist
   - Requires pamela-clipart-registry.js loaded first
   - Waits for registry to load manifest before rendering
*/

(function () {
  "use strict";

  function el(tag, attrs, cssText) {
    const n = document.createElement(tag);
    if (attrs) {
      for (const k in attrs) {
        if (k === "text") n.textContent = attrs[k];
        else if (k === "html") n.innerHTML = attrs[k];
        else n.setAttribute(k, attrs[k]);
      }
    }
    if (cssText) n.style.cssText = cssText;
    return n;
  }

  function waitFor(fn, { timeoutMs = 10000, intervalMs = 50 } = {}) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const t = setInterval(() => {
        try {
          const v = fn();
          if (v) {
            clearInterval(t);
            resolve(v);
            return;
          }
          if (Date.now() - start > timeoutMs) {
            clearInterval(t);
            reject(new Error("Timed out waiting for required state."));
          }
        } catch (_) {}
      }, intervalMs);
    });
  }

  function formatLabel(label) {
    return String(label || "")
      .trim()
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  function ensurePanel() {
    let panel = document.getElementById("pamela-clipart-panel");
    if (panel) return panel;

    panel = el(
      "div",
      { id: "pamela-clipart-panel" },
      "position:fixed;top:0;right:0;height:100vh;width:380px;max-width:90vw;" +
        "background:#fff;border-left:1px solid rgba(0,0,0,.15);z-index:999999;" +
        "box-shadow:-12px 0 30px rgba(0,0,0,.12);display:none;overflow:hidden;"
    );

    const header = el(
      "div",
      { id: "pamela-clipart-panel-header" },
      "padding:12px 12px;border-bottom:1px solid rgba(0,0,0,.12);" +
        "display:flex;gap:10px;align-items:center;justify-content:space-between;"
    );

    const title = el("div", { text: "Clipart Library" }, "font-weight:900;font-size:14px;");
    const closeBtn = el(
      "button",
      { type: "button", id: "pamela-clipart-panel-close", text: "✕", "aria-label": "Close" },
      "width:36px;height:36px;border-radius:10px;border:1px solid rgba(0,0,0,0.2);" +
        "background:#fff;color:#111;font-weight:900;cursor:pointer;"
    );
    closeBtn.addEventListener("click", () => {
      panel.style.display = "none";
    });

    header.appendChild(title);
    header.appendChild(closeBtn);

    const body = el(
      "div",
      { id: "pamela-clipart-panel-body" },
      "height:calc(100vh - 54px);overflow:auto;padding:12px;"
    );

    const searchRow = el("div", { id: "pamela-clipart-searchrow" }, "display:flex;gap:8px;align-items:center;margin-bottom:10px;");
    const search = el(
      "input",
      { id: "pamela-clipart-search", type: "text", placeholder: "Search…" },
      "flex:1;min-width:140px;padding:10px 12px;border-radius:14px;border:1px solid rgba(0,0,0,.15);font-weight:900;font-size:14px;"
    );
    const clear = el(
      "button",
      { id: "pamela-clipart-search-clear", type: "button", text: "Clear" },
      "padding:10px 14px;border-radius:14px;border:1px solid rgba(0,0,0,.15);background:#fff;cursor:pointer;font-weight:900;font-size:13px;"
    );
    searchRow.appendChild(search);
    searchRow.appendChild(clear);

    const filters = el(
      "div",
      { id: "pamela-clipart-filters" },
      "display:flex;gap:10px;align-items:flex-start;margin-bottom:12px;flex-wrap:wrap;"
    );

    const categoryField = el(
      "label",
      { id: "pamela-clipart-category-field" },
      "display:flex;flex:1 1 150px;min-width:0;flex-direction:column;gap:5px;font-size:11px;font-weight:900;color:#555;"
    );
    categoryField.appendChild(el("span", { text: "Category" }));

    const categorySelect = el(
      "select",
      { id: "pamela-clipart-category-select", "aria-label": "Clipart category" },
      "width:100%;height:42px;padding:0 34px 0 12px;border-radius:14px;border:1px solid rgba(0,0,0,.15);" +
        "background:#fff;color:#111;font-weight:900;font-size:14px;cursor:pointer;"
    );
    categoryField.appendChild(categorySelect);

    const subField = el(
      "div",
      { id: "pamela-clipart-subcategory-field" },
      "position:relative;display:flex;flex:1 1 170px;min-width:0;flex-direction:column;gap:5px;font-size:11px;font-weight:900;color:#555;"
    );
    subField.appendChild(el("span", { text: "Subcategory" }));

    const comboWrap = el("div", { id: "pamela-clipart-subcategory-combo" }, "position:relative;");
    const subInput = el(
      "input",
      {
        id: "pamela-clipart-subcategory-input",
        type: "text",
        autocomplete: "off",
        role: "combobox",
        "aria-label": "Clipart subcategory",
        "aria-expanded": "false",
        placeholder: "All"
      },
      "width:100%;height:42px;box-sizing:border-box;padding:0 34px 0 12px;border-radius:14px;border:1px solid rgba(0,0,0,.15);" +
        "background:#fff;color:#111;font-weight:900;font-size:14px;"
    );
    const subArrow = el(
      "button",
      { id: "pamela-clipart-subcategory-toggle", type: "button", text: "v", "aria-label": "Show subcategories" },
      "position:absolute;right:3px;top:3px;width:36px;height:36px;border:0;background:transparent;color:#111;font-size:18px;font-weight:900;cursor:pointer;"
    );
    const subList = el(
      "div",
      { id: "pamela-clipart-subcategory-list", role: "listbox" },
      "position:absolute;left:0;right:0;top:47px;z-index:2;display:none;max-height:240px;overflow:auto;" +
        "background:#fff;border:1px solid rgba(0,0,0,.18);border-radius:14px;box-shadow:0 12px 24px rgba(0,0,0,.16);padding:6px;"
    );
    comboWrap.appendChild(subInput);
    comboWrap.appendChild(subArrow);
    comboWrap.appendChild(subList);
    subField.appendChild(comboWrap);

    filters.appendChild(categoryField);
    filters.appendChild(subField);

    const grid = el("div", { id: "pamela-clipart-grid" }, "display:grid;grid-template-columns:repeat(3, 1fr);gap:10px;");

    body.appendChild(searchRow);
    body.appendChild(filters);
    body.appendChild(grid);

    panel.appendChild(header);
    panel.appendChild(body);

    document.body.appendChild(panel);
    return panel;
  }

  function itemMatches(it, q) {
    if (!q) return true;
    const hay = `${it.id || ""} ${it.name || ""} ${it.rawName || ""} ${it.category || ""} ${it.subcategory || ""}`.toLowerCase();
    return hay.includes(q);
  }

  async function ensureRegistryLoaded() {
    await waitFor(() => typeof window.PAMELA_CLIPART_ENSURE === "function", { timeoutMs: 10000 });
    await window.PAMELA_CLIPART_ENSURE("rings");
    await waitFor(() => window.PAMELA_CLIPART_BY_CAT && Object.keys(window.PAMELA_CLIPART_BY_CAT).length, { timeoutMs: 15000 });
  }

  async function render(panel, options = {}) {
    const filters = panel.querySelector("#pamela-clipart-filters");
    const categorySelect = panel.querySelector("#pamela-clipart-category-select");
    const subInput = panel.querySelector("#pamela-clipart-subcategory-input");
    const subToggle = panel.querySelector("#pamela-clipart-subcategory-toggle");
    const subList = panel.querySelector("#pamela-clipart-subcategory-list");
    const grid = panel.querySelector("#pamela-clipart-grid");
    const search = panel.querySelector("#pamela-clipart-search");
    const clear = panel.querySelector("#pamela-clipart-search-clear");
    const requestedCategory = String(options.category || panel.dataset.initialCategory || window.__PAMELA_CLIPART_REQUESTED_CATEGORY || "").trim().toLowerCase();
    if (requestedCategory) window.__PAMELA_CLIPART_REQUESTED_CATEGORY = "";

    try {
      await ensureRegistryLoaded();
    } catch (e) {
      if (filters) filters.style.display = "none";
      grid.innerHTML = `<div style="grid-column:1/-1;opacity:.75;font-weight:900;">Clipart registry did not load. Check console.</div>`;
      console.error(e);
      return;
    }

    const by = window.PAMELA_CLIPART_BY_CAT || {};
    const cats =
      (Array.isArray(window.PAMELA_CLIPART_CATEGORIES) && window.PAMELA_CLIPART_CATEGORIES.length)
        ? window.PAMELA_CLIPART_CATEGORIES.map((c) => ({ id: c.id, label: c.label }))
        : Object.keys(by).map((id) => ({ id, label: id }));

    if (!cats.length) {
      if (filters) filters.style.display = "none";
      grid.innerHTML = `<div style="grid-column:1/-1;opacity:.75;font-weight:900;">No categories loaded.</div>`;
      return;
    }

    if (filters) filters.style.display = "flex";

    const requestedCat = requestedCategory
      ? cats.find((c) => String(c.id || "").toLowerCase() === requestedCategory || String(c.label || "").toLowerCase() === requestedCategory)
      : null;

    let active = requestedCat ? requestedCat.id : cats[0].id;
    let activeSub = null;
    let activeSubLabel = "";
    let subQuery = "";
    let comboOpen = false;

    function getSubcats() {
      return typeof window.PAMELA_GET_SUBCATEGORIES === "function"
        ? window.PAMELA_GET_SUBCATEGORIES(active)
        : [];
    }

    function openCombo({ selectText = false } = {}) {
      comboOpen = true;
      if (subInput) {
        subInput.setAttribute("aria-expanded", "true");
        subInput.value = subQuery;
        if (selectText) subInput.select();
      }
      drawSubcategoryList();
    }

    function closeCombo() {
      comboOpen = false;
      subQuery = "";
      if (subInput) {
        subInput.setAttribute("aria-expanded", "false");
        subInput.value = activeSubLabel || "";
        subInput.placeholder = `All ${formatLabel(cats.find((c) => c.id === active)?.label || active)}`;
      }
      if (subList) subList.style.display = "none";
    }

    function drawCategorySelect() {
      if (!categorySelect) return;
      categorySelect.innerHTML = "";
      cats.forEach((c) => {
        const opt = el("option", { value: c.id, text: formatLabel(c.label || c.id) });
        categorySelect.appendChild(opt);
      });
      categorySelect.value = active;
    }

    function drawSubcategoryList() {
      if (!subList) return;

      const subcats = getSubcats();
      const categoryLabel = formatLabel(cats.find((c) => c.id === active)?.label || active);
      const q = String(subQuery || "").trim().toLowerCase();
      const activeItems = (window.PAMELA_CLIPART_BY_CAT && window.PAMELA_CLIPART_BY_CAT[active])
        ? window.PAMELA_CLIPART_BY_CAT[active]
        : [];
      const options = [{ id: "", label: `All ${categoryLabel}` }].concat(
        subcats.filter((s) => {
          if (!q) return true;
          if (String(s.label || "").toLowerCase().includes(q)) return true;

          return activeItems.some((it) => {
            const sub = String(it.subcategory || "").trim().toLowerCase();
            return sub === s.id && itemMatches(it, q);
          });
        })
      );

      subList.innerHTML = "";
      if (!comboOpen) {
        subList.style.display = "none";
        return;
      }

      subList.style.display = "block";
      if (!options.length) {
        subList.appendChild(el("div", { text: "No subcategories found" }, "padding:10px 12px;font-weight:900;opacity:.65;"));
        return;
      }

      options.forEach((s) => {
        const selected = activeSub === s.id;
        const option = el(
          "button",
          { type: "button", role: "option", "aria-selected": selected ? "true" : "false", text: formatLabel(s.label) },
          "width:100%;display:block;text-align:left;padding:10px 12px;border:0;border-radius:10px;" +
            (selected ? "background:#111;color:#fff;" : "background:#fff;color:#111;") +
            "cursor:pointer;font-weight:900;font-size:13px;"
        );

        option.addEventListener("mousedown", (e) => {
          e.preventDefault();
          activeSub = s.id || null;
          activeSubLabel = s.id ? formatLabel(s.label) : "";
          closeCombo();
          drawGrid();
        });

        subList.appendChild(option);
      });
    }

    function drawControls() {
      drawCategorySelect();
      if (subInput && !comboOpen) {
        subInput.value = activeSubLabel || "";
        subInput.placeholder = `All ${formatLabel(cats.find((c) => c.id === active)?.label || active)}`;
      }
      drawSubcategoryList();
    }

    function drawGrid() {
      const q = String(search?.value || "").trim().toLowerCase();

      // Grid
      grid.innerHTML = "";
      const items = q
        ? (Array.isArray(window.PAMELA_CLIPART_ALL) ? window.PAMELA_CLIPART_ALL : [])
        : ((window.PAMELA_CLIPART_BY_CAT && window.PAMELA_CLIPART_BY_CAT[active])
          ? window.PAMELA_CLIPART_BY_CAT[active]
          : []);

      const filtered = items.filter((it) => {
        if (!itemMatches(it, q)) return false;

        if (!q && activeSub) {
          const sub = String(it.subcategory || "").trim().toLowerCase();
          return sub === activeSub;
        }

        return true;
      });

      if (!filtered.length) {
        grid.innerHTML = `<div style="grid-column:1/-1;opacity:.75;font-weight:900;">${q ? "No matches." : "No items here yet."}</div>`;
        return;
      }

      filtered.forEach((it) => {
        const cell = el(
          "button",
          { type: "button", title: `${it.subcategory || ""} ${it.id || ""}`.trim() },
          "border:1px solid rgba(0,0,0,.12);border-radius:14px;background:#fff;" +
            "padding:8px;cursor:pointer;display:flex;flex-direction:column;gap:6px;align-items:center;"
        );

        const img = el(
          "img",
          { src: it.url, alt: it.name || "", loading: "lazy" },
          "width:100%;height:90px;object-fit:contain;display:block;"
        );

        const cap = el(
          "div",
          { text: formatLabel(it.name || it.subcategory || "") },
          "font-size:11px;line-height:1.1;font-weight:900;text-align:center;opacity:.9;"
        );

        cell.appendChild(img);
        cell.appendChild(cap);

        cell.addEventListener("click", () => {
          if (typeof window.PAMELA_ADD_CLIPART_TO_STAGE === "function") {
            window.PAMELA_ADD_CLIPART_TO_STAGE(it);
          } else {
            console.warn("Clipart click hook not wired yet (images are displaying).");
          }
        });

        grid.appendChild(cell);
      });
    }

    function draw() {
      drawControls();
      drawGrid();
    }

    categorySelect.onchange = async () => {
      active = categorySelect.value;
      activeSub = null;
      activeSubLabel = "";
      subQuery = "";
      closeCombo();
      await window.PAMELA_CLIPART_ENSURE(active);
      draw();
    };

    subInput.onfocus = () => openCombo({ selectText: true });
    subInput.onclick = () => openCombo({ selectText: true });
    subInput.oninput = () => {
      subQuery = String(subInput.value || "");
      comboOpen = true;
      subInput.setAttribute("aria-expanded", "true");
      drawSubcategoryList();
    };
    subInput.onkeydown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        closeCombo();
      }
      if (e.key === "Enter") {
        const first = subList?.querySelector?.("button");
        if (first) {
          e.preventDefault();
          first.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true }));
        }
      }
    };
    subInput.onblur = () => {
      window.setTimeout(closeCombo, 120);
    };
    subToggle.onclick = () => {
      if (comboOpen) closeCombo();
      else {
        subQuery = "";
        openCombo({ selectText: true });
        subInput?.focus();
      }
    };

    search.oninput = drawGrid;
    clear.onclick = () => {
      if (search) search.value = "";
      drawGrid();
    };

    window.PAMELA_CLIPART_ENSURE(active).then(draw).catch((e) => {
      console.error(e);
      draw();
    });
  }

  async function open(options = {}) {
    const panel = ensurePanel();
    panel.style.display = "block";
    if (options.category) panel.dataset.initialCategory = String(options.category);
    else delete panel.dataset.initialCategory;
    await render(panel, options);
  }

  function close() {
    const panel = document.getElementById("pamela-clipart-panel");
    if (panel) panel.style.display = "none";
  }

  async function toggle(options = {}) {
    const panel = ensurePanel();
    const opening = panel.style.display === "none" || !panel.style.display;
    if (opening) {
      await open(options);
    } else {
      close();
    }
  }

  async function openToCategory(category) {
    await open({ category });
  }

  function bindButton() {
    const btn = document.getElementById("pamela-view-clipart");
    if (!btn) return false;

    const clone = btn.cloneNode(true);
    btn.parentNode.replaceChild(clone, btn);

    clone.addEventListener("click", async () => {
      await toggle();
    });

    return true;
  }

  function start() {
    let tries = 0;
    const t = setInterval(() => {
      tries++;
      if (bindButton()) return clearInterval(t);
      if (tries > 40) clearInterval(t);
    }, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  window.PAMELA_CLIPART_UI = {
    open,
    close,
    toggle,
    openToCategory,
  };
})();
